<script lang="ts">
    import ShortcodeFragment from "./ShortcodeFragment.svelte"

    export let html: string
    export let components: {
        [code: string]: any
    }
</script>

{#if html}
    {#key html}
        <fragment>
            <ShortcodeFragment html="{html}" components="{components}" />
        </fragment>
    {/key}
{/if}
